import { render, staticRenderFns } from "./arrived.vue?vue&type=template&id=6c786e9a"
import script from "./arrived.vue?vue&type=script&lang=js"
export * from "./arrived.vue?vue&type=script&lang=js"
import style0 from "./arrived.vue?vue&type=style&index=0&id=6c786e9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports